import { useTranslation } from '@/hooks/useTranslation';
import { irremediabilityCriteriaChoices } from '../picker/IroIrremediabilityPicker';
import { CriteriaRatingTable } from './CriteriaRatingTable';
import { IroFormula } from './IroFormula';
import { IrremediabilityValueDefinition } from '@/graphql/generated';

export function IrremediabilityCriteriaDefinition({
  definitions,
}: {
  definitions: IrremediabilityValueDefinition[];
}) {
  const { t } = useTranslation();
  const items = irremediabilityCriteriaChoices(t);
  return (
    <div>
      <h1 className="p-8 bg-gray-50 border-b border-gray-100 title-h3 capitalize">
        {t('translation:iro.criteria.irremediability.title')}
      </h1>
      <div className="p-8 space-y-8">
        <p className="">{t('iro.criteria.irremediability.definition')}</p>
        <hr />
        <div className="space-y-2">
          <h2 className="title-h4">{t('iro.criteria.rating.title')}</h2>
          <CriteriaRatingTable items={items} definitions={definitions} />
        </div>
        <hr />
        <div className="space-y-2">
          <h2 className="title-h4">{t('iro.criteria.formula.title')}</h2>
          <IroFormula />
        </div>
      </div>
    </div>
  );
}
